export enum PaymentType {
    UNSPECIFIED = 'unspecified',
    MONTHLY = 'monthly',
    DAILY = 'daily',
}
